document.addEventListener('DOMContentLoaded', function() {
    const animatedRead = document.querySelector('.animated-read-multi');

    if (animatedRead) {
        const animImagesInSection = animatedRead.querySelectorAll('.anim-img');

        if (animImagesInSection.length > 1) {
            const cards = document.querySelectorAll('.animated-read-multi .text-scroll-card');
            const images = document.querySelectorAll('.animated-read-multi .sticky-container img');

            // Initialize images' opacity
            images.forEach(img => {
                img.style.opacity = '0';
                img.classList.add('transition-ready');
            });

            // Create intersection observer for regular cards (excluding first and last)
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    const cardIndex = Array.from(cards).indexOf(entry.target);

                    if (entry.isIntersecting) {
                        // Fade in the corresponding image
                        if (images[cardIndex]) {
                            images[cardIndex].style.opacity = '1';
                        }
                    } else {
                        // Fade out the corresponding image if it's not the last one
                        if (cardIndex < cards.length - 1) {
                            if (images[cardIndex]) {
                                images[cardIndex].style.opacity = '0';
                            }
                        }
                    }
                });
            }, {
                threshold: 0 // Adjust as needed for when the image should start fading in/out
            });

            // Create intersection observer for the first and last cards with a threshold of 0
            const edgeCardObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    const cardIndex = Array.from(cards).indexOf(entry.target);

                    if (entry.isIntersecting) {
                        // Fade in the edge image
                        if (images[cardIndex]) {
                            images[cardIndex].style.opacity = '1';
                        }
                    } else {
                        // Fade out the edge image
                        if (images[cardIndex]) {
                            images[cardIndex].style.opacity = '0';
                        }
                    }
                });
            }, {
                threshold: 0
            });

            function handleViewportChange() {
                if (window.innerWidth >= 992) {
                    cards.forEach((card, index) => {
                        if (index === 0 || index === cards.length - 1) {
                            edgeCardObserver.observe(card);
                        } else {
                            observer.observe(card);
                        }
                    });
                } else {
                    cards.forEach((card, index) => {
                        if (index === 0 || index === cards.length - 1) {
                            edgeCardObserver.unobserve(card);
                        } else {
                            observer.unobserve(card);
                        }
                    });
                }
            }

            window.addEventListener('resize', handleViewportChange);
            handleViewportChange();

            // Add required CSS
            const style = document.createElement('style');
            style.textContent = `
                .animated-read-multi .sticky-container img {
                    // transition: opacity 0.5s ease-in-out;
                    will-change: opacity;
                }
            `;
            document.head.appendChild(style);
        }
    }
});